import React, { useState } from "react";
import { useSelector } from "react-redux";
import ParticipantSearchComponent from "./participantSearch.component";

export default function ParticipantSearchContainer({
  handleFilter,
  isFetching,
}) {
  const [search, setSearch] = useState("");
  const handleSearch = async (values) => {
    await handleFilter(values);
  };
  const lang = useSelector((state) => state.constant.languages);

  return (
    <ParticipantSearchComponent
      handleSearch={handleSearch}
      lang={lang}
      isFetching={isFetching}
      search={search}
      setSearch={setSearch}
    />
  );
}
